import { VURL, Assert } from "js-vextensions";
import { GetPage, GetSubpage } from "../../Store/main";
import { StoreAccessor } from "mobx-firelink";
import { GetSelectedProposalID } from "firebase-feedback";
export const rootPages = [
    "users", "feedback", "more",
    "home",
    "write",
];
// a default-child is only used (ie. removed from url) if there are no path-nodes after it
export const rootPageDefaultChilds = {
    feedback: "proposals",
    more: "links",
    home: "home",
};
export function PushHistoryEntry() {
    // history.pushState({}, document.title, GetNewURL());
    history.pushState({}, document.title, window.location.href);
}
export function NormalizeURL(url) {
    const result = url.Clone();
    if (!rootPages.Contains(result.pathNodes[0])) {
        result.pathNodes.Insert(0, "home");
    }
    if (result.pathNodes[1] == null && rootPageDefaultChilds[result.pathNodes[0]]) {
        result.pathNodes.Insert(1, rootPageDefaultChilds[result.pathNodes[0]]);
    }
    return result;
}
export function GetCurrentURL_SimplifiedForPageViewTracking() {
    // let result = URL.Current();
    const result = GetNewURL(false);
    /* const mapID = GetOpenMapID();
    const onMapPage = NormalizeURL(result).toString({ domain: false }).startsWith('/global/map');
    if (mapID && onMapPage) {
        const nodeID = GetFocusedNodeID(mapID);
        const node = nodeID ? GetNodeL2(nodeID) : null;
        // if (result.pathNodes.length == 1) {
        /* if (NormalizeURL(result).toString({domain: false}).startsWith("/global/map") && result.pathNodes.length == 1) {
            result.pathNodes.push("map");
        } *#/
        if (node) {
            result = NormalizeURL(result);
            result.pathNodes.push(GetCrawlerURLStrForNode(node));
        }
    } */
    return result;
}
// loading
// ==========
const pagesWithSimpleSubpages = ["home", "more", "write"].ToMap(page => page, () => null);
export function GetLoadActionFuncForURL(url) {
    return (store) => {
        url = NormalizeURL(url);
        const page = url.pathNodes[0];
        store.main.page = page;
        const subpage = url.pathNodes[1];
        if (url.pathNodes[1] && page in pagesWithSimpleSubpages) {
            store.main[page].subpage = subpage;
        }
        // load query-vars
        if (url.GetQueryVar("extra"))
            store.main.urlExtraStr = url.GetQueryVar("extra") == "null" ? null : url.GetQueryVar("extra");
        if (url.GetQueryVar("env"))
            store.main.envOverride = url.GetQueryVar("env") == "null" ? null : url.GetQueryVar("env");
        if (url.GetQueryVar("db"))
            store.main.dbOverride = url.GetQueryVar("db") == "null" ? null : url.GetQueryVar("db");
        if (url.GetQueryVar("dbVersion"))
            store.main.dbVersionOverride = url.GetQueryVar("dbVersion") == "null" ? null : url.GetQueryVar("dbVersion");
        if (url.GetQueryVar("analyticsEnabled"))
            store.main.analyticsEnabled = url.GetQueryVar("analyticsEnabled") == "true";
        /* if (url.pathNodes[0] == 'forum') {
            const subforumStr = url.pathNodes[1];
            if (subforumStr != '*') {
                const subforumIDMatch = subforumStr && subforumStr.match(/([0-9]+)$/);
                const subforumID = subforumIDMatch ? subforumIDMatch[1].ToInt() : null;
                result.push(new ACTSubforumSelect({ id: subforumID }));
            }

            const threadStr = url.pathNodes[2];
            const threadIDMatch = threadStr && threadStr.match(/([0-9]+)$/);
            const threadID = threadIDMatch ? threadIDMatch[1].ToInt() : null;
            result.push(new ACTThreadSelect({ id: threadID }));
        } */
        if (page == "feedback") {
            if (subpage == "proposals") {
                const idStr = url.pathNodes[2];
                const idStrMatch = idStr && idStr.match(/([A-Za-z0-9_-]+)$/);
                const proposalID = idStrMatch ? idStrMatch[1] : null;
                store.feedback.main.proposals.selectedProposalID = proposalID;
            }
        }
        if (page == "database") {
        }
    };
}
// saving
// ==========
//g.justChangedURLFromCode = false;
export const GetNewURL = StoreAccessor("GetNewURL", s => (includeMapViewStr = true) => {
    // let newURL = URL.Current();
    /* let oldURL = URL.Current(true);
    let newURL = new VURL(oldURL.domain, oldURL.pathNodes); */
    const newURL = new VURL();
    const page = GetPage();
    newURL.pathNodes.push(page);
    const subpage = GetSubpage();
    if (page in pagesWithSimpleSubpages) {
        newURL.pathNodes.push(subpage);
    }
    // query vars
    if (s.main.urlExtraStr)
        newURL.SetQueryVar("extra", s.main.urlExtraStr);
    if (!s.main.analyticsEnabled && newURL.GetQueryVar("analytics") == null)
        newURL.SetQueryVar("analytics", "false");
    if (s.main.envOverride)
        newURL.SetQueryVar("env", s.main.envOverride);
    if (s.main.dbOverride)
        newURL.SetQueryVar("db", s.main.dbOverride);
    if (s.main.dbVersionOverride)
        newURL.SetQueryVar("dbVersion", s.main.dbVersionOverride);
    /* if (page == 'forum') {
        const subforumID = GetSelectedSubforumID();
        const threadID = GetSelectedThreadID();
        if (subforumID) newURL.pathNodes.push(`${subforumID}`);
        else if (threadID) newURL.pathNodes.push('*');

        if (threadID) newURL.pathNodes.push(`${threadID}`);
    } */
    if (page == "feedback") {
        const proposalID = GetSelectedProposalID();
        if (proposalID)
            newURL.pathNodes.push(`${proposalID}`);
    }
    let mapID;
    if (page == "XXX") {
    }
    // a default-child is only used (ie. removed from url) if there are no path-nodes after it
    if (subpage && subpage == rootPageDefaultChilds[page] && newURL.pathNodes.length == 2)
        newURL.pathNodes.length = 1;
    if (page == "home" && newURL.pathNodes.length == 1)
        newURL.pathNodes.length = 0;
    Assert(!newURL.pathNodes.Any(a => a == "/"), `A path-node cannot be just "/". @url(${newURL})`);
    return newURL;
});
export function DoesURLChangeCountAsPageChange(oldURL, newURL) {
    if (oldURL == null)
        return true;
    if (oldURL.PathStr() != newURL.PathStr())
        return true;
    return false;
}
/*export function RecordPageView(url: VURL) {
    // let url = window.location.pathname;
    if (PROD) {
        // todo: ms if react-ga is not initialized yet, we buffer up these commands, then run them once it is initialized
        ReactGA.set({page: url.toString({domain: false})});
        ReactGA.pageview(url.toString({domain: false}) || "/");
    }
    MaybeLog(a=>a.pageViews, ()=>`Page-view: ${url}`);
}*/ 
